(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oleoya-calendrier-diversification"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buttons = document.querySelectorAll('[data-cd-export]');
    if (!buttons.length) return;

    const FILE = 'tableau-diversification-oleoya.png';
    let lib = null;
    let image = null;

    const loadLib = () => {
      if (window.html2canvas) return Promise.resolve(window.html2canvas);
      lib = lib || new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        s.onload = () => resolve(window.html2canvas);
        s.onerror = () => { lib = null; reject(new Error('html2canvas')); };
        document.head.appendChild(s);
      });
      return lib;
    };

    // Affiche propre : titre, légende, tableau complet (sans liens ni colonne collante), source.
    const buildPoster = () => {
      const section = document.getElementById('tableau');
      const poster = document.createElement('div');
      poster.className = 'cd-poster';
      poster.setAttribute('aria-hidden', 'true');
      poster.innerHTML =
        '<div class="cd-poster__head"><div><p class="cd-poster__eyebrow">Repères du carnet de santé</p>' +
        '<p class="cd-poster__title">La diversification alimentaire de 0 à 3 ans</p></div>' +
        '<p class="cd-poster__brand">Oléoya</p></div>';
      poster.appendChild(section.querySelector('.cd-legend').cloneNode(true));
      const table = section.querySelector('.cd-table').cloneNode(true);
      table.querySelectorAll('a').forEach((a) => a.replaceWith(...a.childNodes));
      table.querySelector('caption')?.remove();
      poster.appendChild(table);
      poster.insertAdjacentHTML(
        'beforeend',
        '<div class="cd-poster__foot"><p>c. à café = cuillère à café ; c. à soupe = cuillère à soupe ; j = jour. Repères par jour, à adapter à l’appétit de l’enfant.</p>' +
        '<p>oleoya.fr/outils/calendrier-diversification-alimentaire</p></div>'
      );
      section.closest('.cd').appendChild(poster);
      return poster;
    };

    const render = async () => {
      if (image) return image;
      const html2canvas = await loadLib();
      if (document.fonts) await document.fonts.ready;
      const poster = buildPoster();
      try {
        const canvas = await html2canvas(poster, {
          scale: 2,
          backgroundColor: '#fffaf0',
          logging: false,
          onclone: (doc) => {
            const clone = doc.querySelector('.cd-poster');
            if (clone) clone.style.left = '0';
          },
        });
        image = canvas.toDataURL('image/png');
        return image;
      } finally {
        poster.remove();
      }
    };

    const printImage = (src) => {
      const frame = document.createElement('iframe');
      frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
      document.body.appendChild(frame);
      const doc = frame.contentDocument;
      doc.open();
      doc.write(
        '<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Tableau de la diversification – Oléoya</title>' +
        '<style>@page{size:A4 landscape;margin:8mm}html,body{margin:0}' +
        'img{display:block;width:100%;height:auto;max-height:190mm;object-fit:contain}</style></head>' +
        '<body><img alt="Tableau de la diversification alimentaire" src="' + src + '"></body></html>'
      );
      doc.close();
      const img = doc.querySelector('img');
      const go = () => {
        frame.contentWindow.focus();
        frame.contentWindow.print();
        setTimeout(() => frame.remove(), 60000);
      };
      if (img.complete) go(); else img.onload = go;
    };

    const download = (src) => {
      const a = document.createElement('a');
      a.href = src;
      a.download = FILE;
      document.body.appendChild(a);
      a.click();
      a.remove();
    };

    buttons.forEach((button) => {
      button.addEventListener('click', async () => {
        const label = button.textContent;
        buttons.forEach((b) => { b.disabled = true; });
        button.textContent = 'Préparation…';
        try {
          const src = await render();
          if (button.dataset.cdExport === 'image') download(src);
          else printImage(src);
        } catch (e) {
          window.print();
        } finally {
          button.textContent = label;
          buttons.forEach((b) => { b.disabled = false; });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
